var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-select", {
    attrs: {
      items: _vm.items,
      "item-text": "name",
      "item-value": "id",
      label: _vm.label,
      clearable: _vm.clearable,
      multiple: _vm.multiple,
      "return-object": !_vm.multiple,
      disabled: _vm.disabled,
      "hide-details": "",
    },
    scopedSlots: _vm._u([
      {
        key: "selection",
        fn: function ({ item, index }) {
          return [
            index === 0
              ? _c("span", [_c("span", [_vm._v(_vm._s(item.name))])])
              : _vm._e(),
            index === 1
              ? _c("span", { staticClass: "grey--text text-caption" }, [
                  _vm._v(" (+" + _vm._s(_vm.value.length - 1) + " others) "),
                ])
              : _vm._e(),
          ]
        },
      },
    ]),
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v
      },
      expression: "value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }